import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { INotification } from '../interfaces/notifications/INotification';
import { INotificationsResponse } from '../interfaces/notifications/INotificationsResponse';
import { normalizeNotificationData } from '../interfaces/notifications/normalize-notification-data';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}notifications`;

  public getPendingNotifications(): Observable<INotification[]> {
    return this.http.get<INotificationsResponse>(this.baseUrl).pipe(map(this.normalizeNotifications));
  }

  public getPersistentNotifications(): Observable<INotification[]> {
    return this.http
      .get<INotificationsResponse>(this.baseUrl, { params: { includeComputed: false } })
      .pipe(map(this.normalizeNotifications));
  }

  public dismissNotification(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  private normalizeNotifications(response: INotificationsResponse): INotification[] {
    return response.notifications.map(notification => ({
      ...notification,
      data: normalizeNotificationData(notification.data),
    }));
  }
}
